import './parcelRowCounter.scss'
import templateUrl from './parcelRowCounter.html'

/**
 * Renders expected/detected progress bar. Used in table rows
 *
 * @example
 * <tmr-parcel-row-counter
 *  counters="parcel.$counters"
 * ></tmr-parcel-row-counter>
 *
 * @type {ngComponent}
 * @prop {object} counters
 */
export const tmrParcelRowCounter = {
  ngType: 'component',
  templateUrl,
  bindings: {
    counters: '<',
  },
}
